'use es6';

import Actions from '../lib/Actions';
import GlobalFiltersRecord from 'AdsUI/records/reporting/GlobalFiltersRecord';
export default ((state = new GlobalFiltersRecord(), action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Actions.GLOBAL_FILTER_CHANGE:
      return state.merge(payload);

    default:
      return state;
  }
});